import Icons from "../assets/icon";
import Img from "../assets/image/index";

const TierBtnData = [
  {
    id: 1,
    roleIcons: Icons.rollFanIcons,
    disabled: false,
    btnLayout: "xs:w-24 xs:h-7 sm:w-28 sm:h-7 xl:w-28 lg:24 xl:h-12",
    btntitle: "FAN",
    award: [
      {
        id: 1,
        awardImg: Img.EMERALDtonesImg,
        awardPosition: '-right-2 sm:-right-2 lg:-right-2 xl:-right-3',
        isComingSoon: false,
        bgColor: "#1DCCA8",
        title: "EMERALD",
        pricing: "0",
        pricingperuser: "per user",
        pricingpermonth: "per month",
        point1: "Invitation to exclusive memberships by GEM",
        point2: "Complete access to GEM the networking community",
        point3: "Registration as a Talent, Employer or, Vendor",
        point4: "Digital membership cards",
        btntitle: "Get Started",
      },
      {
        id: 2,
        awardImg: Img.RUBYtonesImg,
        awardPosition: '-right-2.5 sm:-right-3 lg:-right-3 xl:-right-7',
        isComingSoon: false,
        bgColor: "#FC7336",
        title: "RUBY",
        pricing: "10",
        isPkR: "(3K PKR)",
        pricingperuser: "per user",
        pricingpermonth: "per month",
        point1: "Invitation to exclusive memberships by GEM",
        point2: "Complete access to GEM the networking community",
        point3: "Registration as a Talent, Employer or, Vendor",
        point4: "Digital membership cards",
        btntitle: "Get Started",
      },
      {
        id: 3,
        awardImg: Img.SAPPHIREtonesImg,
        awardPosition: '-right-2.5 sm:-right-4 lg:-right-6 xl:-right-10',
        isComingSoon: false,
        bgColor: "#FCCE36",
        title: "SAPPHIRE",
        pricing: "29.99",
        isPkR: "(9K PKR)",
        pricingperuser: "per user",
        pricingpermonth: "per month",
        point1: "Access to Tier 1 & 2 benefits",
        point2: "Up to 25% off on tickets for GEM and partner events",
        point3: "Attractive discounts at various local and national retailers",
        point4: "Invitation to bi-annual GEM Gold Members events",
        point5: "Substantial (Plastic) membership cards",
        btntitle: "Get Started",
      },
      {
        id: 4,
        awardImg: Img.DIAMONDtonesImg,
        awardPosition: '-right-2 sm:-right-3 lg:-right-5 xl:-right-7',
        bgColor: "#5CFC36",
        title: "DIAMOND",
        pricing: "TBD",
        isComingSoon: true,
        pricingperuser: "per user",
        pricingpermonth: "per month",
        point1: "Access to Tier 1,2 & 3 benefits",
        point2: "Up to 50% off on tickets for GEM and partner events",
        point3: "Exciting discounts at various local, national, and international retailers",
        point4: "Access to exclusive lounges and cafes in different eateries",
        point5: "Invitation to 1 high-profile, exclusive GEM event with founders and co-founders",
        point6: "Eligibility to attend GEM private parties and screen nobles",
        point7: "Exclusive celebrity meet & greet",
        point8: "Networking Events",
        point9: "Substantial (metal) membership cards",
        btntitle: "Coming Soon",
      },
    ]
  },
];

export default TierBtnData;
